import { render, staticRenderFns } from "./UploadVendorProcedure.vue?vue&type=template&id=0e964bf3&scoped=true&"
import script from "./UploadVendorProcedure.vue?vue&type=script&lang=js&"
export * from "./UploadVendorProcedure.vue?vue&type=script&lang=js&"
import style0 from "./UploadVendorProcedure.vue?vue&type=style&index=0&id=0e964bf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e964bf3",
  null
  
)

component.options.__file = "UploadVendorProcedure.vue"
export default component.exports